import React from "react";
import { checkExamRequirementCodeType } from "../helper";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import useStyles from "./styles";

const HISA_LINK_TEXT =
  "https://hisa-resources-public.s3.amazonaws.com/how-to-fill-out-and-submit-a-post-layoff-report-visual-guide.pdf";
const TSE1_LINK_TEXT =
  "https://chrb.ca.gov/veterinary_forms/chrb_136_access-0825.pdf";

interface IProps {
  examRequirementTypeCode: racehorse360.HorseExamRequirementTypeCode;
}

const ExternalExamFormLinks = (props: IProps) => {
  const { examRequirementTypeCode } = props;

  const classes = useStyles();

  const { isTse1Type, isHisaType } = checkExamRequirementCodeType(
    examRequirementTypeCode
  );

  return (
    <>
      {isHisaType && (
        <a
          href={HISA_LINK_TEXT}
          target={"_blank"}
          rel="noopener noreferrer"
          className={classes.link}
        >
          View HISA Form
        </a>
      )}
      {isTse1Type && (
        <a
          href={TSE1_LINK_TEXT}
          target={"_blank"}
          rel="noopener noreferrer"
          className={classes.link}
        >
          View TSE-1 Form
        </a>
      )}
    </>
  );
};

export default React.memo(ExternalExamFormLinks);
